<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, onMounted, watchEffect } from "vue";
import Step1Place from "@/components/Step1Place/Step1Place.vue";
import Step2Dates from "@/components/Step2Dates/Step2Dates.vue";
import Step3Details from "@/components/Step3Details/Step3Details.vue";
import Step4Applicant from "@/components/Step4Applicant/Step4Applicant.vue";
import Step5Recap from "@/components/Step5Recap/Step5Recap.vue";
import Step6Confirmed from "../Step6Confirmed/Step6Confirmed.vue";
import { useStore } from "vuex";
import { SESSION_EXPIRATION_MINUTES } from "@/store";
import StepPayment from "../StepPayment/StepPayment.vue";
import { getReservationDetailById } from "@/api/httpApi";
import ToastNotifications from "@/components/shared/ToastNotifications.vue";
const store = useStore();

const reservationIdDetails = ref();
const reservationStatusLabel = ref();
const reservationStatusPaymentLabel = ref();
const steps = ref([]);
let intervalId = null;
let stepsSettings = [];
stepsSettings = {
  stepForm: {
    steps: [
      { name: "Luogo", title: "Step 1", description: "Step 1 subtitle" },
      { name: "Data e orario", title: "Step 2", description: "Step 2 subtitle" },
      { name: "Dettagli", title: "Step 3", description: "Step 3 subtitle" },
      { name: "Richiedente", title: "Step 4", description: "Step 4 subtitle" },
      { name: "Riepilogo", title: "Step 5", description: "Step 5 subtitle" },
      { name: "Appuntamento confermato", title: "Step 6", description: "Step 6 subtitle" },
      { name: "Pagamento andato a buon fine", title: "Step 7", description: "Step 7 subtitle" },
    ],
  },
};

stepsSettings.stepForm.steps.forEach(function (step) {
  steps.value.push(step);
});

const modalRef = ref(null);

function next() {
  if (store.state.currentStep < steps.value.length - 1) {
    store.commit("setStep", store.state.currentStep + 1);
  }

  const elementToTop = document.getElementById("top-stepper");

  if (elementToTop) {
    setTimeout(() => {
      window.scrollTo({
        top: elementToTop.offsetTop - elementToTop.offsetHeight,
        left: 0,
        behavior: "smooth",
      });
    }, 500);
  }
}

function prev() {
  if (store.state.currentStep > 0) {
    store.commit("setStep", store.state.currentStep - 1);
  }

  const elementToTop = document.getElementById("top-stepper");

  if (elementToTop) {
    setTimeout(() => {
      window.scrollTo({
        top: elementToTop.offsetTop - elementToTop.offsetHeight,
        left: 0,
        behavior: "smooth",
      });
    }, 500);
  }
}

function goto(i) {
  store.commit("setStep", i);
}

function checkExpiration() {
  let reservationDate = store.state.reservationDate
    ? new Date(store.state.reservationDate)
    : undefined;
  if (!reservationDate) return false;
  let diff = reservationDate ? (new Date() - reservationDate) / 60000 : 0;
  return diff > SESSION_EXPIRATION_MINUTES;
}

function resetIfExpired() {
  if (!checkExpiration()) return;
  store.commit("setStep", 0);
  store.commit("setResourceId", "");
  store.commit("setErogationMode", "fis");
  store.commit("setNumberOfReservations", 1);
  store.commit("setYear", undefined);
  store.commit("setMonth", undefined);
  store.commit("setDay", undefined);
  store.commit("setHour", undefined);
  store.commit("setSlots", []);
  store.commit("setReservationId", undefined);
  store.commit("setServiceId", undefined);
  store.commit("setServiceSlotNumber", 1);
  store.commit("setDetail", "");
  store.commit("setAttributes", {});
  store.commit("setUser", {});
  store.commit("setSearched", false);
  store.commit("setOfficeId", undefined);
  store.commit("setTopicId", undefined);
  store.commit("setSearched", undefined);
  store.commit("setIsRecapping", false);
  store.commit("setIdentifyValues", []);

  const elementToTop = document.getElementById("top-stepper");

  if (elementToTop) {
    setTimeout(() => {
      window.scrollTo({
        top: elementToTop.offsetTop - elementToTop.offsetHeight,
        left: 0,
        behavior: "smooth",
      });
    }, 500);
  }
  modalRef?.value?.show();
}

const prepareStatusReservation = (status) => {
  switch (status) {
    case "A":
      return "Prenotazione in approvazione";
    case "B":
      return "Prenotazione in compilazione";
    case "C":
      return "Prenotazione confermata";
    case "D":
      return "Prenotazione cancellata";
    case "E":
      return "Pagamento in corso";
    case "F":
      return "Prenotazione da ripianificare";
    case "6":
      return "Cittadino presentato";
    case "H":
      return "Cittadino non presentato";
    case "P":
      return "Prenotazione in attesa di pagamento";
    case "R":
      return "Prenotazione in attesa di ricevuta telematica";
    default:
      return status;
  }
};

const prepareStatusPayment = (status) => {
  switch (status) {
    case "OK":
      return "Pagamento effettuato";
    case "ERROR":
      return "Pagamento rifiutato";
    case "DEFERRED":
      return "Pagamento differito";
    default:
      return status;
  }
};

watchEffect(async () => {
  const searchReservationId = store.state.reservationId;
  const currentStep = store.state.currentStep;
  if ((currentStep === 5 || currentStep === 6) && searchReservationId) {
    try {
      reservationIdDetails.value = await getReservationDetailById(
        searchReservationId
      );
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
        modalRef?.value?.hide();
      }
    } catch (err) {
      console.error(err);
    }
  }
});

watchEffect(async () => {
  const searchReservationId = store.state.reservationId;
  const currentStep = store.state.currentStep;
  if (currentStep && searchReservationId && reservationIdDetails) {
    reservationStatusLabel.value = prepareStatusReservation(
      reservationIdDetails?.value?.reservationStatus
    );
  }
});

watchEffect(async () => {
  const searchReservationId = store.state.reservationId;
  const currentStep = store.state.currentStep;
  if (currentStep && searchReservationId && reservationIdDetails) {
    reservationStatusPaymentLabel.value = prepareStatusPayment(
      reservationIdDetails?.value?.paymentLastOutcome
    );
  }
});

onMounted(() => {
  intervalId = setInterval(resetIfExpired, 5000);
  modalRef.value = new window.bootstrap.Modal(
    document.getElementById("expiredModal")
  );

  window.onpopstate = function () {
    resetIfExpired();
  };
});
</script>

<template>
  <div style="scroll-behavior: smooth">
    <h1
      id="top-stepper"
      class="d-block h1 text-primary title mb-4 ms-1 p-2"
      v-if="![5, 6].includes(store.state.currentStep)"
      >Prenotazione appuntamento</h1>
    <h1
      id="top-stepper"
      class="d-flex align-items-center gap-2 mb-0 mb-md-4 p-2"
      v-if="store.state.currentStep === 5">
      <svg class="icon icon-sm icon-success icon-color m-1" aria-hidden="true">
        <use
          :href="`/${store.state.modulePath}/assets/svg/sprites.svg#it-check-circle`"
        ></use>
      </svg>
      <span class="d-block h1 text-primary title">{{
        reservationStatusLabel
      }}</span>
    </h1>

    <h1
      id="top-stepper"
      class="d-block h1 text-primary title mb-4 ms-1 p-2"
      v-if="store.state.currentStep === 6"
      >{{ reservationStatusPaymentLabel }}</h1>

    <div class="steppers">
      <div
        class="steppers-header"
        v-if="![5, 6].includes(store.state.currentStep)">
        <ul>
          <li
            v-for="(step, idx) in steps.filter(
              (s) => !['Step 6', 'Step 7'].includes(s.title)
            )"
            :key="step"
            :class="{ active: store.state.currentStep === idx }">
            {{ step.name.toUpperCase() }}
          </li>
        </ul>
        <span class="steppers-index" aria-hidden="true">{{ store.state.currentStep + 1 }}/{{ steps.length }}</span>
      </div>
      <div class="steppers-content" aria-live="polite">
        <Step1Place
          v-if="store.state.currentStep === 0"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <Step2Dates
          v-if="store.state.currentStep === 1"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <Step3Details
          v-if="store.state.currentStep === 2"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <Step4Applicant
          v-if="store.state.currentStep === 3"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <Step5Recap
          v-if="store.state.currentStep === 4"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <Step6Confirmed
          v-if="store.state.currentStep === 5"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
        <StepPayment
          v-if="store.state.currentStep === 6"
          @next="next"
          @previous="prev"
          @goto="goto"
        />
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="expiredModal"
      aria-labelledby="expiredModalTitle">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title h5" id="expiredModalTitle">
              Sessione scaduta
            </h2>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary btn-sm"
              data-bs-dismiss="modal"
              type="button">
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<ToastNotifications
  :id="`stepperFormToast`"
  :type="`error`"
  :title="`Informazioni mancanti`">
  <p id="stepperFormToastBody"></p>
</ToastNotifications>
</template>
